import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import { translate } from '@haldor/ui';
import { connect } from "react-redux";
import { addError } from "actions";
import { saveBlocksOnReference } from 'actions/blocks';
import { createBulkPlans } from 'actions/plans';
import { createAssessmentBlock } from "actions/blocks";
import { Form, Field } from "react-final-form";
import Select from "components/Inputs/select";
import DatePickerFromTo from "../Partials/DatePickerFromTo";
import MultipleSectionSelector from "../Partials/MultipleSectionSelector";
import TeacherAdjustments from "containers/AdditionalAdjustments/Display/TeacherAdjustments";
import BlockEditor from 'components/BlockEditor';
import BlockAssessments from 'components/BlockAssessments';
import BlockPurpose from "components/Inputs/BlockPurposeField";
import BlockCoreContentField from "components/Inputs/BlockCoreContentField";
import { Expandable, Spinner } from "UI";
import { Icon, Button, Checkbox } from '@haldor/ui';
import api from "lib/api";

var MultiplePlanForm = /*#__PURE__*/function (_Component) {
  _inherits(MultiplePlanForm, _Component);

  var _super = _createSuper(MultiplePlanForm);

  function MultiplePlanForm(props) {
    var _this;

    _classCallCheck(this, MultiplePlanForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "required", function (value) {
      if (typeof value !== "undefined" && value !== "") {
        if (value.length > 199) {
          // Field failed validation, return error for this field (String)
          return _this.props.translate("field-max-200-chars");
        } // Field passes validation, return a undefined error for this field
        // Rule: Not undefined and not an empty string and not over 200 characters


        return undefined;
      } // Field failed validation, return error for this field (String)


      return _this.props.translate("field-needs-input");
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      return new Promise(function (resolve) {
        var blocks = [];
        var assessmentBlocks = [];
        var promises = [];

        if (values.assessmentBlocks != null) {
          assessmentBlocks = _toConsumableArray(values.assessmentBlocks);
        }

        if (values.blocks != null) {
          blocks = _toConsumableArray(values.blocks);
          blocks.forEach(function (block) {
            if (block.type == 'Haldor.Blocks.Assignment') {
              if (block.resources != null) {
                var resources = [];
                block.resources.forEach(function (resource) {
                  if (resource.existing) {
                    assessmentBlocks.forEach(function (block) {
                      promises.push(new Promise(function (resolve) {
                        if (resource['@odata.type'] == 'haldor.assignment.block.teamsassignment') {
                          api.get("assignments/".concat(resource.id, "/details")).then(function (response) {
                            _this.props.createAssessmentBlock(block, response.data.id, 'ASSIGNMENT').then(function () {
                              resolve(1);
                            });
                          });
                          return true;
                        }

                        _this.props.createAssessmentBlock(block, resource.id, 'ASSIGNMENT').then(function () {
                          resolve(1);
                        });
                      }));
                    });
                  }

                  resources.push({
                    id: resource.id,
                    '@odata.type': resource['@odata.type']
                  });
                });
                block.resources = resources;
              }
            }

            return block;
          });
        }

        delete values.blocks;
        delete values.assessmentBlocks;
        values.timeStart = _this.state.dateStart.set({
          hour: 0,
          minute: 0,
          second: 0,
          millisecond: 0
        });
        values.timeEnd = _this.state.dateEnd.set({
          hour: 23,
          minute: 59
        });
        values.description = values.description;
        values.sections = _this.state.sections;
        values.sections.forEach(function (section) {
          section.courses = []; //We dont need to send courses
        });

        var that = _assertThisInitialized(_this);

        _this.props.createBulkPlans(values).then(function (plan) {
          if (_this.props.createdPlans != null && blocks != null && blocks.length > 0) {
            _this.props.createdPlans.forEach(function (createdPlan) {
              promises.push(new Promise(function (resolve) {
                _this.props.saveBlocksOnReference(blocks, createdPlan.id, 'PLAN').then(function () {
                  resolve(1);
                });
              }));
              assessmentBlocks.forEach(function (block) {
                promises.push(new Promise(function (resolve) {
                  _this.props.createAssessmentBlock(block, createdPlan.id, 'PLAN').then(function () {
                    resolve(1);
                  });
                }));
              });
            });
          }

          Promise.all(promises).then(function () {
            that.props.onAbort(true, true);
          });
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDescriptionChange", function (content) {
      _this.setState({
        description: content
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDateChange", function (dates) {
      _this.setState({
        dateStart: dates.start,
        dateEnd: dates.end
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onStatusSelect", function (event) {
      _this.setState({
        status: event.target.value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (_ref) {
      var input = _ref.input,
          label = _ref.label,
          type = _ref.type,
          placeholder = _ref.placeholder,
          _ref$meta = _ref.meta,
          touched = _ref$meta.touched,
          error = _ref$meta.error,
          warning = _ref$meta.warning;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", _extends({
        type: type
      }, input, {
        placeholder: placeholder || label,
        onKeyPress: function onKeyPress(e) {
          if (e.key == 'Enter') {
            e.preventDefault();
          }
        },
        style: touched && error ? {
          border: "1px solid red"
        } : {}
      })), touched && (error && /*#__PURE__*/React.createElement("span", {
        style: {
          marginTop: "1rem",
          color: "red"
        }
      }, error) || warning && /*#__PURE__*/React.createElement("span", {
        style: {
          marginTop: "1rem",
          color: "red"
        }
      }, warning)));
    });

    _defineProperty(_assertThisInitialized(_this), "onSectionsChange", function (groups) {
      _this.setState({
        sections: groups
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onAddSectionCourse", function (newGroups) {
      var sections = _this.state.sections;
      sections.forEach(function (section) {
        var newData = newGroups.find(function (group) {
          return group.id == section.id;
        });

        if (newData != null) {
          section.courses = newData.courses;
        }

        return section;
      });

      _this.setState({
        sections: sections
      });
    });

    _this.state = {
      dateStart: null,
      dateEnd: null,
      status: null,
      sections: [],
      associatedMatrices: [],
      loading: false
    };
    return _this;
  }
  /* Component methods and events */


  _createClass(MultiplePlanForm, [{
    key: "isIframe",
    value: function isIframe() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    }
    /* Redux form functions */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var statuses = this.props.status.planningStatus.filter(function (t) {
        return t.selectable;
      });
      var groups = [];

      if (this.state.sections.length > 0) {
        this.state.sections.forEach(function (section) {
          return groups.push(section.id);
        });
      }

      if (this.state.loading) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }

      var disabledBlocks = [];

      if (this.props.selectedSections.length == 0 || this.props.selectedSections.length > 1) {
        disabledBlocks.push({
          name: 'Haldor.Blocks.Assignment',
          text: 'Before the planning is saved, you can only add assignments if you have selected one (1) group. When the planning is saved, you can go into the planning for each group and assign assignments.'
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "form-container form"
      }, /*#__PURE__*/React.createElement(Form, {
        onSubmit: this.submit,
        mutators: {
          setStatusDraft: function setStatusDraft(args, state, utils) {
            utils.changeValue(state, 'status', function () {
              return 'PLANNING_DRAFT';
            });
          },
          setStatusOpen: function setStatusOpen(args, state, utils) {
            utils.changeValue(state, 'status', function () {
              return 'PLANNING_OPEN';
            });
          }
        },
        initialValues: this.props.initialValues,
        render: function render(_ref2) {
          var _form$getFieldState, _form$getFieldState2;

          var handleSubmit = _ref2.handleSubmit,
              form = _ref2.form,
              valid = _ref2.valid,
              submitting = _ref2.submitting,
              initialValues = _ref2.initialValues;
          var disableGroups = false;
          var blockValues = (_form$getFieldState = form.getFieldState('blocks')) === null || _form$getFieldState === void 0 ? void 0 : _form$getFieldState.value;
          var assessmentBlocks = (_form$getFieldState2 = form.getFieldState('assessmentBlocks')) === null || _form$getFieldState2 === void 0 ? void 0 : _form$getFieldState2.value;
          var subjects = [];

          if ((assessmentBlocks === null || assessmentBlocks === void 0 ? void 0 : assessmentBlocks.length) > 0) {
            assessmentBlocks === null || assessmentBlocks === void 0 ? void 0 : assessmentBlocks.forEach(function (content) {
              var _content$resources;

              content === null || content === void 0 ? void 0 : (_content$resources = content.resources) === null || _content$resources === void 0 ? void 0 : _content$resources.forEach(function (resources) {
                if ((resources === null || resources === void 0 ? void 0 : resources.value) != null) {
                  var _resources$value;

                  if (subjects.indexOf((_resources$value = resources.value) === null || _resources$value === void 0 ? void 0 : _resources$value.subjectId) == -1) {
                    var _resources$value2;

                    subjects.push(parseInt((_resources$value2 = resources.value) === null || _resources$value2 === void 0 ? void 0 : _resources$value2.subjectId));
                  }
                }
              });
            });
          }

          if (blockValues != null && blockValues.length > 0) {
            disableGroups = blockValues.findIndex(function (block) {
              return block.type == 'Haldor.Blocks.Assignment';
            }) > -1;
          }

          return /*#__PURE__*/React.createElement("form", {
            onSubmit: handleSubmit,
            className: "form form-component"
          }, submitting ? /*#__PURE__*/React.createElement("div", {
            className: "is_sending"
          }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
            className: "loading-spinner"
          }))) : null, /*#__PURE__*/React.createElement(Expandable, {
            contentStyles: {
              padding: "1em 0rem"
            },
            contentStylesClosed: {
              padding: "0"
            },
            headerStyles: _this2.state.error != null ? {
              border: "1px solid red"
            } : {},
            whiteBackground: true,
            title: _this2.props.translate("choose-groups"),
            open: true,
            ignorePropsUpdate: true
          }, /*#__PURE__*/React.createElement(MultipleSectionSelector, {
            onChange: _this2.onSectionsChange,
            disabled: disableGroups,
            type: "plan"
          }), disableGroups ? /*#__PURE__*/React.createElement("div", {
            className: "group-selector-info"
          }, /*#__PURE__*/React.createElement(Icon, {
            name: "Alert"
          }), _this2.props.translate("To be able to add or delete groups, you must first delete the assignments that are in this plan. Assignments that you have already created are saved outside the planning and are searchable.")) : null), _this2.props.editView && initialValues.status != "PLANNING_DRAFT" ? /*#__PURE__*/React.createElement("div", {
            className: "form-row"
          }, /*#__PURE__*/React.createElement(Select, {
            name: "type",
            label: _this2.props.translate("status"),
            dataType: "plan",
            options: statuses,
            placeholder: false,
            onChange: _this2.onStatusSelect,
            selectedValue: initialValues.status
          })) : null, /*#__PURE__*/React.createElement("div", {
            className: "form-row"
          }, /*#__PURE__*/React.createElement(DatePickerFromTo, {
            type: "plan",
            onChange: _this2.onDateChange,
            values: initialValues
          })), /*#__PURE__*/React.createElement("div", {
            className: "form-row input"
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate("title"), "*"), /*#__PURE__*/React.createElement(Field, {
            component: _this2.renderInput,
            type: "text",
            name: "title",
            placeholder: _this2.props.translate("title"),
            validate: _this2.required
          })), /*#__PURE__*/React.createElement("div", {
            className: "form-divider"
          }), /*#__PURE__*/React.createElement(Expandable, {
            title: _this2.props.translate('Assessments')
          }, /*#__PURE__*/React.createElement(Field, {
            component: BlockAssessments,
            name: "assessmentBlocks"
          })), /*#__PURE__*/React.createElement(Expandable, {
            title: _this2.props.translate('aim')
          }, /*#__PURE__*/React.createElement("div", {
            className: "form-row",
            style: {
              padding: 0,
              marginBottom: "1em"
            }
          }, /*#__PURE__*/React.createElement("div", {
            className: "conditional-groups-container"
          }, /*#__PURE__*/React.createElement(Field, {
            name: "viewablePurpose",
            component: Checkbox,
            label: _this2.props.translate("Show aim to students")
          }))), /*#__PURE__*/React.createElement(Field, {
            component: BlockPurpose,
            name: "purpose",
            assessmentBlocks: assessmentBlocks
          })), /*#__PURE__*/React.createElement(Expandable, {
            title: _this2.props.translate("central-content")
          }, /*#__PURE__*/React.createElement("div", {
            className: "form-row",
            style: {
              padding: 0,
              marginBottom: "1em"
            }
          }, /*#__PURE__*/React.createElement("div", {
            className: "conditional-groups-container"
          }, /*#__PURE__*/React.createElement(Field, {
            name: "viewableCoreContent",
            component: Checkbox,
            label: _this2.props.translate("Show subject content to students")
          })), /*#__PURE__*/React.createElement("div", {
            style: {
              clear: "both"
            }
          })), /*#__PURE__*/React.createElement(Field, {
            component: BlockCoreContentField,
            name: "associatedCoreContent"
          })), _this2.props.services.additionalAdjustments ? /*#__PURE__*/React.createElement(Expandable, {
            title: _this2.props.translate("additional-adjustments")
          }, /*#__PURE__*/React.createElement(TeacherAdjustments, {
            disableCommenting: true,
            groups: groups,
            subjects: subjects
          })) : null, /*#__PURE__*/React.createElement(Field, {
            component: BlockEditor,
            name: "blocks",
            disabled: disabledBlocks,
            planningAssessments: (assessmentBlocks === null || assessmentBlocks === void 0 ? void 0 : assessmentBlocks.length) > 0 ? assessmentBlocks : []
          }), /*#__PURE__*/React.createElement("div", {
            className: "form-divider"
          }), /*#__PURE__*/React.createElement("div", {
            className: "form-row spacing submit"
          }, /*#__PURE__*/React.createElement(Button, {
            onClick: function onClick(e) {
              e.preventDefault();
              form.mutators.setStatusOpen();
              form.submit();
            },
            disabled: submitting || !valid || _this2.state.sections.length == 0
          }, _this2.props.translate("publish")), /*#__PURE__*/React.createElement(Button, {
            onClick: function onClick(e) {
              e.preventDefault();
              form.mutators.setStatusDraft();
              form.submit();
            },
            type: "secondary",
            disabled: submitting || !valid || _this2.state.sections.length == 0
          }, _this2.props.translate("save-draft")), /*#__PURE__*/React.createElement("div", {
            className: "align-right"
          }, /*#__PURE__*/React.createElement(Button, {
            type: "secondary",
            onClick: function onClick(e) {
              e.preventDefault();

              _this2.props.onAbort(false);
            }
          }, _this2.props.translate("Cancel")))));
        }
      }));
    }
  }]);

  return MultiplePlanForm;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    status: state.status.status,
    groups: state.sections.educationGroups,
    services: state.Services.availableServices,
    createdPlans: state.planning.createdPlans,
    selectedSections: state.sections.selected,
    initialValues: {
      viewablePurpose: false,
      viewableCoreContent: true
    }
  };
}

export default connect(mapStateToProps, {
  createBulkPlans: createBulkPlans,
  addError: addError,
  saveBlocksOnReference: saveBlocksOnReference,
  createAssessmentBlock: createAssessmentBlock
})(MultiplePlanForm);